import Autocomplete from 'vuejs-auto-complete'
import getApiClient from '@/plugins/api'

export default {
    name: 'BankInput',
    props: {
        value: String
    },
    data: function () {
        return {
            apiUrl: process.env.VUE_APP_API_URL,
            displayValue: null,
        }
    },
    computed: {
        searchHeaders: function() {
            return {
                Authorization: `Bearer ${this.$store.state.jwtToken}`
            }
        },
    },
    components: {
        Autocomplete,
    },
    methods: {
        setValue: function(data) {
            this.$emit('input', data.value)
        },
        loadInitialValue: function() {
            const self = this,
              api = getApiClient(self.$store)

            if (this.value) {
                api.get(`banks/${this.value}`, {
                    headers: {
                        'Accept': 'application/json'
                    }
                })
                  .then(response => {
                      self.displayValue = response.data.name
                  })
            }
        },
    },
    mounted: function() {
        this.loadInitialValue()
    }
}
